<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
          color="primary"
          title="Company Protocol list"
          text=""
          class="elevation-1"
        >
          <v-btn
            color="pink"
            style="margin-right:10px"
            dark
            small
            absolute
            top
            right
            @click="upsertDialog({isNew:true, company:{}, protocol:{}})"
            v-if="$can('upsert', 'company_protocol')"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <v-data-table
            id="company_has_protocol_dataTable"
            :headers="headers"
            :items="company_has_protocol"
            :pagination.sync="pagination"
            :total-items="totalCompanyProtocols"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
          >
            <v-progress-linear
              v-slot:progress
              color="primary"
              indeterminate
            ></v-progress-linear>

            <!--template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-dark text-success text-darken-3"
                v-text="header.text"
              />
            </template-->

            <template slot="headers" slot-scope="props">
              <tr>
                <th 
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === pagination.sortBy &&
                    header.sortable != false ? 'active' : ''
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>mdi-menu-down</v-icon>
                  <span 
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  />
                </th>
              </tr>
              <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filters.hasOwnProperty(header.value)">
                    <v-text-field
                      clearable
                      md4
                      v-if="filters[header.value].type == 'text'"
                      v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder"
                      @input="filterChanged(filters[header.value])"
                    />

                    <v-select
                      clearable
                      md4
                      v-if="filters[header.value].type == 'list'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-text="filters[header.value].item_text"
                      :item-value="filters[header.value].item_value"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @change="filterChanged(filters[header.value])"
                    ></v-select>

                    <v-autocomplete
                      clearable
                      md4
                      v-if="filters[header.value].type == 'autocomplete'"
                      v-model="filters[header.value].value"
                      :items="filters[header.value].list"
                      :item-value="filters[header.value].item_value"
                      :item-text="filters[header.value].item_text"
                      :placeholder="filters[header.value].placeholder"
                      class="purple-input"
                      @change="filterChanged(filters[header.value])"
                    ></v-autocomplete>
                  </div>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
             
              <td class="text-xs-left">{{ item.protocol.name }}</td>
              <td class="text-xs-left">{{ item.company.name }}</td>
              <td class="text-xs-left">{{ item.protocol_company_code }}</td>

              <td class="text-xs-right">

                <v-tooltip top>
                  <template slot="activator" slot-scope="{ on }">
                    <!--router-link :to="{ name: 'Protocol Detail', params: { id: item.id } }">
                      <v-icon v-on="on" color="primary">mdi-pencil</v-icon>
                    </router-link-->
                    <a flat @click="upsertDialog(item)">
                        <v-icon v-on="on" color="primary">mdi-pencil</v-icon>
                      </a>
                  </template>
                  <span>Edit Company Protocol</span>
                </v-tooltip>

                <v-tooltip top v-if="$can('delete', 'company_protocol')">
                  <template slot="activator" slot-scope="{ on }">
                    <a flat @click="companyProtocolItem = item; deleteDialog = true" class="ml-2">
                      <v-icon v-if="$can('delete', 'company_protocol')" v-on="on" color="primary">mdi-delete-forever</v-icon>
                    </a>
                  </template>
                  <span>Remove Company</span>
                </v-tooltip>


                <v-tooltip top>
                  <template slot="activator" slot-scope="{ on }">
                    <a flat @click="openAuditTrail(item)" class="ml-2">
                      <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
                    </a>
                  </template>
                  <span>Audit Trail</span>
                </v-tooltip>

                <!--v-btn :to="'/project/' + item.id" icon>
                  <v-icon color="black">mdi-pencil</v-icon>
                </v-btn-->

                <!--v-menu offset-x left bottom>
                  <v-btn icon slot="activator">
                    <v-icon color="black">mdi-pencil</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-title>Teste</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-title>Teste</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-title>Teste</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-title>Teste</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu-->
              </td>
            </template>
          </v-data-table>
        </material-card>

      </v-flex>
    </v-layout>

    <safety-company-protocol-upsert-modal v-model="companyProtocolDialog" :item="companyProtocolItem"/>
    <safety-delete-modal v-model="deleteDialog" entity="Company Protocol" :entityId="companyProtocolItem.company.name + ' / ' + companyProtocolItem.protocol.name" @confirm="confirmDelete"/>
    <v-dialog v-model="auditTrail.open" width="1200px">
      <safety-audittrail-timeline v-if='auditTrail.open' entity="company_has_protocol" :entity_id='auditTrail.entityId' :fields="headers"/>
    </v-dialog>

  </v-container>
</template>


<script>
import { getList, remove } from "@/api/company_has_protocol";
import { normalizeFilters } from "@/utils/filters";

export default {
  data() {
    return {
      companyProtocolItem: {company:{}, protocol:{}},
      companyProtocolDialog: false,
      deleteDialog: false,
      pagination: {
        rowsPerPage: 5,
        page: 1,
        sortBy: 'company_id',
        descending: true,
        totalItems: undefined
      },
      auditTrail: {
        open: false,
        entityId: null
      },
      rowsPerPageItems: [5,10,25],
      loading: true,
      totalCompanyProtocols: 0,
      headers: [
        {
          text: "Protocol",
          align: "left",
          sortable: true,
          value: "protocol.name"
        },
        {
          text: "Company",
          align: "left",
          sortable: true,
          value: "company.name"
        },
        {
          text: "Protocol Company Code",
          align: "left",
          sortable: true,
          value: "protocol_company_code"
        },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ],
      // filters: {
      //   name: {
      //     value: undefined,
      //     replace: "VALUE%"
      //   },
      // },
      company_has_protocol: []
    };
  },
  watch: {
    pagination: {
      handler(val, oldVal) {
         if (val.page != oldVal.page || val.rowsPerPage != oldVal.rowsPerPage ||  
          val.sortBy != oldVal.sortBy || val.descending != oldVal.descending) {
          this.getData();
        }
      },
      deep: true
    },
    filters: {
      handler(val) {
        this.pagination.page = 1;
        this.getData();
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", false);
  },
  mounted() {
    this.getData();
    this.$root.$on('updateCompanyProtocols', () => {
      this.getData();
    });
  },
  computed: {
    filters() {
        return {
          'protocol.name': {
            type:'list',
            list: this.$store.getters.protocols,
            value: undefined,
            placeholder: 'Choose',
            item_text:"name",
            item_value:"name"
          },
          'company.name': {
            type:'text',
            replace: "%VALUE%",
            placeholder: 'Search'
          },
          'protocol.sponsor_id': {
            value: this.$store.getters.sponsor_id
          },
        }
     }
  },
  methods: {
    openAuditTrail (item) {
      this.auditTrail.entityId = `${item.company_id}_${item.protocol_id}`
      this.auditTrail.open = true
    },
    getData() {
      this.loading = true;
      getList(normalizeFilters(this.filters), this.pagination).then(data => {
        this.company_has_protocol = data.data;
        this.pagination.rowsPerPage = data.perPage;
        this.pagination.page = data.currentPage;
        this.pagination.totalItems = data.tot;
        this.totalCompanyProtocols = data.tot;
        this.loading = false;
      });
    },
    filterChanged(filter) {
      this.getData();
      console.log("Filter changed", filter)
    },
    changeSort(column) {
      const oldPagination = JSON.parse(JSON.stringify(this.pagination));
      oldPagination.page = 1;
      if (oldPagination.sortBy === column) {
        oldPagination.descending = !oldPagination.descending;
      } else {
        oldPagination.sortBy = column;
        oldPagination.descending = false;
      }
      this.pagination = oldPagination;
    },
    upsertDialog(item = {}) {
      this.companyProtocolItem = JSON.parse(JSON.stringify(item));
      this.companyProtocolDialog = true;
    },
    confirmDelete() {
      remove(this.companyProtocolItem.company.id, this.companyProtocolItem.protocol.id).then( id => {
        this.getData();
        this.$store.dispatch("app/openSnackbar", {
          message: "Company Protocol deleted successfully",
          color: "success"
        });
      }).catch( errorData => {
        let message = errorData.response.data.message;
        if (message.search("foreign key constraint") ) {
           message = "This record has already been used and cannot be removed";
        }
        this.$store.dispatch("app/openSnackbar", {
          message: "Company Protocol Delete error : " +  message,
          color: "error"
        });
      });

    }
  }
};
</script>

<style lang="scss">
#company_has_protocol_dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
      padding: 0px 5px 0px 5px;
  }
}
</style>